// extracted by mini-css-extract-plugin
export default {"gender":"GenderItem_gender__DPncx","gender__img":"GenderItem_gender__img__Or9yC"};